export const authorityUserType = {
  userTypeNumber: {
    KIKO: "1", //機構職員
    KEIYAKUSYA: "2", //法人契約者
    TAISYOKUSYA: "4", //退職者
    DAIKOSHA: "6", //代行者
    BENGOSHI: "5", //弁護士
    FUKUSHI: "3", //社会福祉協議会
  },
} as const;

export const pageAccreditationMapping = {
  // "新画面ID
  // (基本設計)"	画面名	契約者	代行者	退職者	弁護士	都道府県社福	機構	補足
  // SCRC010001	ログイン	Y	Y			Y	Y	ログイン画面は共通【認証不要】
  // SCRC030001	社会福施設職員等退職手当共済制度　共済契約のお申込み	Y					Y	(機構)SCR0113【認証不要】
  // SCRC010002	パスワード変更申請	Y						【認証不要】
  // SCRC010003	パスワード変更	Y	Y				Y	【認証不要】
  // SCRC020001	共済契約者ホーム	Y
  // SCRC030102	新規契約情報入力（法人情報）	Y					Y
  // SCRC050102	新規契約情報入力（施設情報）一覧	Y					Y
  // SCRC060106	職員情報新規登録	Y					Y
  // SCRC060007	新規契約申込提出確認	Y					Y	(機構)SCR0113_1
  // SCRC040101	契約者照会	Y					Y
  // SCRC040002	契約者基本情報　更新	Y					Y	(機構)SCR0115
  // SCRC040103	「俸給の調整額」登録済及び登録非該当手当一覧	Y	Y				Y	代行者は手当追加ボタンは使えない
  // SCRC040004	「俸給の調整額」新規申請	Y					Y	(機構)SCR0117
  // SCRC040106	契約者・法人担当者情報の確認・変更	Y					Y
  // SCRC050106	契約解除（経営者でなくなった）内容入力	Y					Y
  // SCRC050107	契約解除（経営者でなくなった）対象施設一覧	Y					Y
  // SCRC050108	契約解除（経営者でなくなった）対象職員一覧	Y					Y
  // SCRC050009	契約解除（経営者でなくなった）入力内容確認	Y					Y	(機構)SCR0123
  // SCRC050113	契約解除（加入者全員の同意）内容入力	Y					Y
  // SCRC050114	従業状況の更新　施設一覧	Y					Y
  // SCRC050115	直近3ヶ月の退職者一覧	Y					Y
  // SCRC050016	契約解除（加入者全員の同意）入力内容確認	Y					Y	(機構)SCR0125
  // SCRC050110	契約解除（中小企業退職金共済契約締結）内容入力	Y					Y
  // SCRC050111	従業状況確認	Y					Y
  // SCRC050012	契約解除（中退共済契約締結）入力内容確認	Y					Y	(機構)SCR0127
  // SCRC050101	施設情報　新規登録	Y					Y
  // SCRC050103	施設等新設届の職員情報登録	Y					Y
  // SCRC050104	新規登録職員一覧	Y					Y
  // SCRC050105	施設等新設届の提出確認	Y					Y
  // SCRC050017	施設情報の変更登録	Y					Y	(機構)SCR0134
  // SCRC050029	措置入所障害児職員数、特定職員数の見込数変更	Y					Y	(機構)SCR0136
  // SCRC050018	施設転換後非加入　新規登録	Y					Y	(機構)SCR0139
  // SCRC050019	非加入の取下げ登録	Y					Y	(機構)SCR0140
  // SCRC050120	廃止・休止・経営移管施設選択	Y					Y
  // SCRC050121	廃止・休止・経営移管施設一覧	Y					Y
  // SCRC050122	廃止・休止・経営移管施設情報登録	Y					Y
  // SCRC050123	職員の異動状況登録	Y					Y
  // SCRC050024	廃止・休止・経営移管施設内容確認	Y					Y	(機構)SCR0145
  // SCRC050125	部分解除　施設選択	Y					Y
  // SCRC050126	部分解除対象施設一覧	Y					Y
  // SCRC050127	部分解除　内容入力	Y					Y
  // SCRC050028	部分解除　入力内容確認	Y					Y	(機構)SCR0148
  // SCRC060112	従業状況更新	Y	Y					(機構)SCR0158
  // SCRC060111	職員一覧　配置換え登録（施設新設）	Y					Y
  // SCRC060103	職員一覧　配置換え登録	Y	Y				Y
  // SCRC060104	配置換え　内容入力	Y	Y				Y
  // SCRC060105	職員一覧　配置換え確認	Y	Y				Y
  // SCRC060013	共済契約対象（外）施設等異動　対象者一覧	Y	Y				Y	(機構)SCR0188_1
  // SCRC060114	共済契約対象施設への復帰情報	Y	Y				Y
  // SCRC060115	共済契約対象外施設への異動情報	Y	Y				Y
  // SCRC070007	登録方法選択	Y
  // SCRC060108	加入登録手続き	Y	Y				Y
  // SCRC060009	加入登録手続き　内容確認	Y	Y				Y
  // SCRC060110	加入登録手続き	Y					Y	(機構)SCR0280
  // SCRC060116	職員一覧　本俸月額更新	Y	Y				Y
  // SCRC060101	育児休業情報登録	Y	Y				Y
  // SCRC060102	育児休業情報確認	Y	Y				Y
  // SCRC060017	職員照会	Y	Y
  // SCRC060118	退職予定者一覧	Y	Y				Y
  // SCRC060119	退職情報　登録時の事前確認	Y	Y				Y
  // SCRC060120	退職情報　登録	Y Y					Y
  // SCRC060121	退職情報　登録（添付書類の確認）	Y	Y				Y
  // SCRC060122	退職情報　登録（従業状況の確認）	Y	Y				Y
  // SCRC060123	退職情報　登録（本俸月額の登録）	Y	Y				Y
  // SCRC060124	退職情報　登録（退職手当金支払いの順番の登録）	Y	Y				Y
  // SCRC060125	退職情報　登録（添付書類の確認）	Y	Y				Y
  // SCRC060026	退職情報　登録（登録内容の確認）	Y	Y				Y	(機構)SCR0270_8
  // SCRC060127	退職情報　登録（退職者の基本情報登録）	Y	Y				Y
  // SCRC060028	退職情報　登録（登録内容の確認）	Y	Y				Y	(機構)SCR0270_10
  // SCRC060129	退職手当金請求コード	Y	Y				Y
  // SCRC060130	引継ぎコード	Y	Y				Y
  // SCRC060031	退職者状況　管理	Y	Y					退職届提出した職員の一覧
  // SCRC060132	退職届の取り下げ	Y	Y				Y
  // SCRC070101	すべての手続履歴一覧	Y					Y
  // SCRC070002	申請情報詳細（新規契約）	Y						(機構)SCR0172
  // SCRC070003	申請情報詳細（職員情報）一覧	Y	Y				Y	(機構)SCR0172_1
  // SCRC070104	申請情報詳細（新設届）	Y						(機構)SCR0176
  // SCRC080001	掛金納付対象職員届提出について	Y
  // SCRC080002	掛金納付対象職員届提出時の事前確認	Y
  // SCRC050030	施設の登録内容の確認	Y						掛金登録の事前確認から、施設登録内容確認する画面
  // SCRC060033	職員の登録内容の確認	Y						掛金登録の事前確認から、職員登録内容確認する画面
  // SCRC080103	掛金納付対象職員届の提出確認	Y					Y
  // SCRC080104	掛金納付対象職員届の提出確認詳細	Y					Y
  // SCRC080105	職員情報	Y					Y
  // SCRC080006	掛金情報確認 施設一覧	Y					Y	(機構)SCR0167
  // SCRC080007	掛金納付対象職員届提出控え、振込依頼書ダウンロード	Y
  // SCRC080008	都道府県社会福祉協議会等への掛金納付対象職員届データの提供の同意について	Y
  // SCRC080009	掛金納付延長申請　内容入力	Y					Y	(機構)SCR0170
  // SCRC090001	チャットボット	Y
  // SCRC090002	機構への連絡掲示板	Y
  // SCRC100001	代行者への処理依頼	Y
  // SCRC100002	代行者の管理	Y
  // SCRC100003	代行者　新規登録	Y	Y
  // SCRC100004	代行処理依頼詳細	Y
  // SCRC100005	代行者への新規依頼	Y
  // SCRC100006	代行者への再依頼	Y
  // SCRC070105	振込先口座情報入力	Y					Y
  // SCRC060134	退職手当金支給予定額の証明依頼書	Y					Y	(機構)SCR0263_1
  // SCRC070008	提出完了	Y	Y				Y	【認証不要】
  // SCRC010004	登録メールアドレスの変更届	Y						(機構)SCR0264_1
  // SCRC020002	マニュアル等	Y	Y
  // SCRD310001	代行者ホーム		Y
  // SCRD310002	依頼内容処理状況管理		Y
  // SCRD310003	処理依頼履歴		Y
  // SCRR410001	退職者入力			Y				【認証不要】
  // SCRR411102	退職手当金の請求手続き又は合算制度利用手続き確認	Y		Y			Y
  // SCRR410003	退職手当金の請求手続き前の書類の準備	Y		Y
  // SCRR410004	退職手当金の請求手続き（退職者確認）	Y		Y
  // SCRR411105	退職手当金の請求手続き（請求者の確認）	Y		Y			Y
  // SCRR411106	退職手当金の請求手続き（請求者情報の登録）	Y		Y			Y
  // SCRR411107	退職手当金の請求手続き（振込先金融機関の登録）	Y		Y			Y
  // SCRR411108	退職手当金の請求手続き（受給権者確認添付書類）	Y		Y			Y
  // SCRR411109	退職手当金の請求手続き（添付書類の登録）	Y		Y			Y
  // SCRR411110	退職手当金の請求手続き（退職所得の受給に関する申告書の登録）	Y		Y			Y
  // SCRR411111	退職手当金の請求手続き（源泉徴収票の確認）	Y		Y			Y
  // SCRR411112	退職手当金の請求手続き（退職所得の源泉徴収票登録）	Y		Y			Y
  // SCRR411113	退職手当金の請求手続き（退職所得の受給に関する申告書兼退職所得申告書の作成）	Y		Y			Y
  // SCRR411114	合算制度利用申出の手続き（連絡先の登録）	Y		Y			Y
  // SCRR411115	退職手当金請求　退職所得情報登録	Y		Y			Y
  // SCRR410016	退職手当金の請求手続き（登録内容の確認）	Y		Y			Y	(機構)SCR0271
  // SCRR410017	合算制度利用申出の手続き（機構への提出確認）	Y		Y			Y	(機構)SCR0272
  // SCRR411118	合算制度利用申出の手続き	Y		Y			Y
  // SCRR411119	退職手当金受領者の変更手続き（連絡先の登録）			Y			Y
  // SCRR411120	退職手当金受領者の変更手続き（退職者との続柄の確認）			Y			Y
  // SCRR411121	退職手当金受領者の変更手続き（請求権者であることを証明する書類の添付）			Y			Y
  // SCRR410022	退職手当金受領者の変更手続き（機構へ連絡）			Y			Y	(機構)SCR0274
  // SCRR411123	退職手当金受領者の変更手続き（請求者の登録）			Y			Y
  // SCRR411124	退職手当金受領者の変更手続き（振込先金融機関の登録）			Y			Y
  // SCRR411125	退職手当金受領者の変更手続き（添付書類の登録）			Y			Y
  // SCRR411126	退職手当金受領者の変更手続き（本人確認の書類の添付）			Y			Y
  // SCRR410027	退職手当金受領者の変更手続き（登録内容の確認）			Y			Y	(機構)SCR0275
  // SCRR410028	退職手当金の請求手続き（請求者情報の登録）			Y			Y	(機構)SCR0276
  // SCRR410030	退職手当金の請求手続き（振込状況の確認）			Y			Y	(機構)SCR0277
  // SCRR010001	退職者認証			Y				【認証不要】
  // SCRC070206	原簿閲覧請求	Y		Y	Y		Y	(機構)SCR0260_1
  // SCRW070012	原簿閲覧請求						Y	(法人)SCR0260
  // SCRW070010	原簿閲覧請求URL送付						Y
  // SCRS080001	掛金対象法人・職員情報照会					Y
  // SCRW080001	掛金届出状況一覧						Y
  // SCRW080002	掛金届出状況詳細						Y
  // SCRW110001	機構職員ホーム						Y
  // SCRW110002	要処理一覧　担当者変更確認						Y
  // SCRW110003	契約者未処理申請・届出等一覧						Y
  // SCRW130001	通知メール						Y
  // SCRW130002	送信メール						Y
  // SCRW130003	メール新規作成						Y
  // SCRW140001	テンプレート一覧						Y
  // SCRW140002	テンプレート新規登録						Y
  // SCRW140003	テンプレート詳細						Y
  // SCRW150001	共済契約者との連絡掲示板						Y
  // SCRW150002	法人との連絡掲示板						Y
  // SCRW160001	入金管理						Y
  // SCRW160002	入金・請求データ　仕分け処理						Y
  // SCRW160003	請求管理						Y
  // SCRW160004	新規請求						Y
  // SCRW160005	請求詳細						Y
  // SCRW160006	支払管理						Y
  // SCRW160007	新規振込先金融機関登録						Y
  // SCRW160009	過納金一覧						Y
  // SCRW160010	割増金一覧						Y
  // SCRW160011	割増金請求						Y
  // SCRW170001	データダウンロード						Y
  // SCRW100001	契約者アカウント一覧						Y
  // SCRW100002	契約者アカウント詳細・更新						Y
  // SCRW100003	ID・権限一覧						Y
  // SCRW100005	アカウント情報更新						Y
  // SCRW210001	補助金交付申請状況一覧						Y
  // SCRW210002	補助金交付申請（概算交付申請内容）						Y
  // SCRW070004	退職手当金追加支給時等　職員情報訂正						Y
  // SCRW070005	掛金確定後の職員情報の訂正						Y
  // SCRW060101	従業状況更新						Y	(法人)SCR0041
  // SCRW110004	紙法人の掛金納付対象職員届の登録						Y
  // SCRW110005	機構職員代行入力						Y
  // SCRW120001	検索画面						Y
  // SCRW120002	検索該当一覧						Y
  // SCRW120004	施設照会						Y
  // SCRW120005	職員照会						Y
  // SCRW070007	契約解除（共済法令違反）内容入力						Y
  // SCRW070008	退職者状況一覧						Y
  // SCRW030001	社会福施設職員等退職手当共済制度　共済契約のお申込み						Y	(法人)SCR0002
  // SCRW040001	契約者基本情報　更新						Y	(法人)SCR0008
  // SCRW040002	「俸給の調整額」新規申請						Y	(法人)SCR0010
  // SCRW050001	契約解除（経営者でなくなった）入力内容確認						Y	(法人)SCR0016
  // SCRW050002	契約解除（加入者全員の同意）入力内容確認						Y	(法人)SCR0018
  // SCRW050003	契約解除（中退共済契約締結）入力内容確認						Y	(法人)SCR0020
  // SCRW050004	施設情報の変更登録						Y	(法人)SCR0026
  // SCRW050006	施設転換後非加入　新規登録						Y	(法人)SCR0031
  // SCRW050007	非加入の取下げ登録						Y	(法人)SCR0032
  // SCRW050008	廃止・休止・経営移管施設内容確認						Y	(法人)SCR0037
  // SCRW050009	部分解除　入力内容確認						Y	(法人)SCR0040
  // SCRW060003	共済契約対象（外）施設等異動　対象者一覧						Y	(法人)SCR0074_1
  // SCRW060004	退職情報　登録（登録内容の確認）						Y	(法人)SCR0054_8
  // SCRW060005	退職情報　登録（登録内容の確認）						Y	(法人)SCR0054_10
  // SCRW070001	申請情報詳細（新規契約）						Y	(法人)SCR0058
  // SCRW070002	申請情報詳細（職員情報）一覧						Y	(法人)SCR0058_1
  // SCRW070003	申請情報詳細（新設届）						Y	(法人)SCR0062
  // SCRW070011	加入登録手続き						Y	(法人)SCR0071_1
  // SCRW080003	掛金情報確認　施設一覧　　　　（※追加納付又は返戻情報の対応で使用）						Y	(法人)SCR0080
  // SCRW080004	掛金納付延長申請　内容入力						Y	(法人)SCR0083
  // SCRW410001	退職手当金の請求手続き（登録内容の確認）						Y	(退職者)SCR0104
  // SCRW410002	合算制度利用申出の手続き（機構への提出確認）						Y	(退職者)SCR0104_2
  // SCRW410004	退職手当金受領者の変更手続き（機構へ連絡）						Y	(退職者)SCR0107_5
  // SCRW410005	退職手当金受領者の変更手続き（登録内容の確認）						Y	(退職者)SCR0108
  // SCRW410006	退職手当金の請求手続き（請求者情報の登録）						Y	(退職者)SCR0105
  // SCRW410030	退職手当金の請求手続き（振込状況の確認）						Y	(退職者)SCR0109
  // SCRW110006	稟議・決裁対象一覧						Y
  // SCRW110007	源泉徴収票の再発行依頼						Y
  // SCRW010001	登録メールアドレスの変更届						Y	(法人)SCR0264
  // SCRW020001	ヘルプ						Y
  // SCRR010002	請求者入力			Y				【認証不要】
  // SCRW060102	退職手当金支給予定額の証明依頼書						Y	(法人)SCR0263
  // SCRW080005	確定後掛金の変更登録						Y

  SCRC010001: ["*"],
  SCRC030001: ["*"],
  SCRC010002: ["*"],
  SCRC010003: ["*"],
  SCRC020001: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC030102: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050102: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060106: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060007: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC040101: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC040002: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC040103: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC040004: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRC040106: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050106: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050107: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050108: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050009: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050113: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050114: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050115: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050016: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050110: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050111: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050012: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050101: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050103: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050104: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050105: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050017: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050029: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050018: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050019: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050120: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050121: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050122: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050123: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050024: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050125: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050126: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050127: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC050028: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060112: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRC060111: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060103: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060104: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060105: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060013: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060033: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060114: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060115: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC070007: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC060108: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060009: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060110: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRC060116: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060101: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060102: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060017: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRC060118: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060119: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060120: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060121: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060122: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060123: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060124: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060125: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060026: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060127: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060028: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060129: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRC060130: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRC060031: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060132: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC070101: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC070002: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC070003: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC070104: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC080001: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC080002: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC050030: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC080103: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC080104: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC080105: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC080006: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC080007: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC080008: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC080009: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC090001: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRC090002: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRC100001: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC100002: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC100003: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRC100004: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC100005: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC100006: [authorityUserType.userTypeNumber.KEIYAKUSYA],
  SCRC070105: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRC060134: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.BENGOSHI,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
  ],
  SCRC070008: ["*"],
  SCRC010004: ["*"],
  SCRC020002: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.DAIKOSHA,
  ],
  SCRD310001: [authorityUserType.userTypeNumber.DAIKOSHA],
  SCRD310002: [authorityUserType.userTypeNumber.DAIKOSHA],
  SCRD310003: [authorityUserType.userTypeNumber.DAIKOSHA],
  SCRR410001: ["*"],
  SCRR411102: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR410003: [
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
  ],
  SCRR410004: [
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
  ],
  SCRR411105: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411106: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411107: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411108: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411109: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411110: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411111: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411112: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411113: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411114: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411115: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR410016: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR410017: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411118: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411119: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411120: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411121: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR410022: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411123: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411124: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411125: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR411126: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR410027: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR410028: [
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
    authorityUserType.userTypeNumber.KEIYAKUSYA,
  ],
  SCRR410030: [
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRR010001: ["*"],
  SCRC070206: [
    authorityUserType.userTypeNumber.KEIYAKUSYA,
    authorityUserType.userTypeNumber.TAISYOKUSYA,
    authorityUserType.userTypeNumber.BENGOSHI,
    authorityUserType.userTypeNumber.KIKO,
  ],
  SCRW070012: [authorityUserType.userTypeNumber.KIKO],
  SCRW070010: [authorityUserType.userTypeNumber.KIKO],
  SCRS080001: [authorityUserType.userTypeNumber.FUKUSHI],
  SCRW080001: [authorityUserType.userTypeNumber.KIKO],
  SCRW080002: [authorityUserType.userTypeNumber.KIKO],
  SCRW110001: [authorityUserType.userTypeNumber.KIKO],
  SCRW110002: [authorityUserType.userTypeNumber.KIKO],
  SCRW110003: [authorityUserType.userTypeNumber.KIKO],
  SCRW130001: [authorityUserType.userTypeNumber.KIKO],
  SCRW130002: [authorityUserType.userTypeNumber.KIKO],
  SCRW130003: [authorityUserType.userTypeNumber.KIKO],
  SCRW140001: [authorityUserType.userTypeNumber.KIKO],
  SCRW140002: [authorityUserType.userTypeNumber.KIKO],
  SCRW140003: [authorityUserType.userTypeNumber.KIKO],
  SCRW150001: [authorityUserType.userTypeNumber.KIKO],
  SCRW150002: [authorityUserType.userTypeNumber.KIKO],
  SCRW160001: [authorityUserType.userTypeNumber.KIKO],
  SCRW160002: [authorityUserType.userTypeNumber.KIKO],
  SCRW160003: [authorityUserType.userTypeNumber.KIKO],
  SCRW160004: [authorityUserType.userTypeNumber.KIKO],
  SCRW160005: [authorityUserType.userTypeNumber.KIKO],
  SCRW160006: [authorityUserType.userTypeNumber.KIKO],
  SCRW160007: [authorityUserType.userTypeNumber.KIKO],
  SCRW160009: [authorityUserType.userTypeNumber.KIKO],
  SCRW160010: [authorityUserType.userTypeNumber.KIKO],
  SCRW160011: [authorityUserType.userTypeNumber.KIKO],
  SCRW170001: [authorityUserType.userTypeNumber.KIKO],
  SCRW100001: [authorityUserType.userTypeNumber.KIKO],
  SCRW100002: [authorityUserType.userTypeNumber.KIKO],
  SCRW100003: [authorityUserType.userTypeNumber.KIKO],
  SCRW100005: [authorityUserType.userTypeNumber.KIKO],
  SCRW210001: [authorityUserType.userTypeNumber.KIKO],
  SCRW210002: [authorityUserType.userTypeNumber.KIKO],
  SCRW070004: [authorityUserType.userTypeNumber.KIKO],
  SCRW070005: [authorityUserType.userTypeNumber.KIKO],
  SCRW060101: [authorityUserType.userTypeNumber.KIKO],
  SCRW110004: [authorityUserType.userTypeNumber.KIKO],
  SCRW110005: [authorityUserType.userTypeNumber.KIKO],
  SCRW120001: [authorityUserType.userTypeNumber.KIKO],
  SCRW120002: [authorityUserType.userTypeNumber.KIKO],
  SCRW120004: [authorityUserType.userTypeNumber.KIKO],
  SCRW120005: [authorityUserType.userTypeNumber.KIKO],
  SCRW070007: [authorityUserType.userTypeNumber.KIKO],
  SCRW070008: [authorityUserType.userTypeNumber.KIKO],
  SCRW030001: [authorityUserType.userTypeNumber.KIKO],
  SCRW040001: [authorityUserType.userTypeNumber.KIKO],
  SCRW040002: [authorityUserType.userTypeNumber.KIKO],
  SCRW050001: [authorityUserType.userTypeNumber.KIKO],
  SCRW050002: [authorityUserType.userTypeNumber.KIKO],
  SCRW050003: [authorityUserType.userTypeNumber.KIKO],
  SCRW050004: [authorityUserType.userTypeNumber.KIKO],
  SCRW050006: [authorityUserType.userTypeNumber.KIKO],
  SCRW050007: [authorityUserType.userTypeNumber.KIKO],
  SCRW050008: [authorityUserType.userTypeNumber.KIKO],
  SCRW050009: [authorityUserType.userTypeNumber.KIKO],
  SCRW060003: [authorityUserType.userTypeNumber.KIKO],
  SCRW060004: [authorityUserType.userTypeNumber.KIKO],
  SCRW060005: [authorityUserType.userTypeNumber.KIKO],
  SCRW070001: [authorityUserType.userTypeNumber.KIKO],
  SCRW070002: [authorityUserType.userTypeNumber.KIKO],
  SCRW070003: [authorityUserType.userTypeNumber.KIKO],
  SCRW070011: [authorityUserType.userTypeNumber.KIKO],
  SCRW080003: [authorityUserType.userTypeNumber.KIKO],
  SCRW080004: [authorityUserType.userTypeNumber.KIKO],
  SCRW410001: [authorityUserType.userTypeNumber.KIKO],
  SCRW410002: [authorityUserType.userTypeNumber.KIKO],
  SCRW410004: [authorityUserType.userTypeNumber.KIKO],
  SCRW410005: [authorityUserType.userTypeNumber.KIKO],
  SCRW410006: [authorityUserType.userTypeNumber.KIKO],
  SCRW410030: [authorityUserType.userTypeNumber.KIKO],
  SCRW110006: [authorityUserType.userTypeNumber.KIKO],
  SCRW110007: [authorityUserType.userTypeNumber.KIKO],
  SCRW010001: [authorityUserType.userTypeNumber.KIKO],
  SCRW020001: [authorityUserType.userTypeNumber.KIKO],
  SCRR010002: ["*"],
  SCRW060102: [authorityUserType.userTypeNumber.KIKO],
  SCRW080005: [authorityUserType.userTypeNumber.KIKO],
};

export default authorityUserType;
